<div class="card card-tabs">
	<div class="card-body">
		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<label for="" class="title">
				Partner
			</label>
			<input type="radio" [(ngModel)]="tab" name="pcss3t" value="0" checked id="tab0" (click)="updateIndexParam(0)">
			<label for="tab0">
				<i class="fa fa-person"></i> Partner
			</label>

			<input type="radio" [(ngModel)]="tab" name="pcss3t" value="1" id="tab1" (click)="updateIndexParam(1)">
			<label for="tab1">
				<i class="fa fa-building"></i> No Asociados
			</label>

			<input type="radio" [(ngModel)]="tab" name="pcss3t" value="2" id="tab2" (click)="updateIndexParam(2)">
			<label for="tab2">
				<i class="fa fa-building"></i> Asociados
			</label>

			<!-- <input type="radio" [(ngModel)]="tab" name="pcss3t" value="2" id="tab2">
			<label for="tab2">
				<i class="fa fa-handshake"></i> Participación
			</label> -->
		</div>
		<div class="card" [hidden]="tab != '0'">
			<div class="card-header">
				<h1>Crear partner</h1>
			</div>
			<div class="card-body" style="margin-bottom: 1em;">
				<div class="row">
					<div class="col form-group">
						<label for="nitAccountant" class="form-label">NIT <i
								class="fa fa-asterisk text-danger"></i></label>
						<input type="text" [(ngModel)]="newAccountant.nit" id="nitAccountant"
							placeholder="Ingresa nit del contador" name="nitAccountant" class="form-control">
					</div>
					<div class="col form-group">
						<label for="nameAccountant" class="form-label">Nombre <i
								class="fa fa-asterisk text-danger"></i></label>
						<input type="text" [(ngModel)]="newAccountant.name" id="nameAccountant" name="nameAccountant"
							placeholder="Ingresa nombre del contador" class="form-control">
					</div>
				</div>
				<div class="row">
					<div class="col form-group">
						<label for="phoneAccountant" class="form-label">Teléfono <i
								class="fa fa-asterisk text-danger"></i></label>
						<input type="text" [(ngModel)]="newAccountant.phone" id="phoneAccountant" name="phoneAccountant"
							placeholder="Ingresa teléfono del contador" class="form-control">
					</div>
					<div class="col form-group">
						<label for="emailAccountant" class="form-label">Correo <i
								class="fa fa-asterisk text-danger"></i></label>
						<input type="text" [(ngModel)]="newAccountant.mail" #emailInput="ngModel" id="emailAccountant"
							name="emailAccountant" placeholder="Ingresa correo del contador" class="form-control"
							(ngModelChange)="validateEmail()">
						<span class="form-text" *ngIf="invalidEmail  && emailInput.dirty"><i
								class="fa fa-warning"></i>Ingresa un correo valido, de la forma usuario@empresa.com</span>
					</div>
					<div class="col form-group">
						<label for="taxRegimenAccountant" class="form-label">Régimen de Impuestos <i
								class="fa fa-asterisk text-danger"></i></label>
						<select [(ngModel)]="newAccountant.taxRegime" id="companyTaxRegime" name="companyTaxRegime"
							class="form-select">
							<option value="1">Pequeño Contribuyente</option>
							<option value="2">Mensual</option>
							<option value="3">Trimestral</option>
						</select>
					</div>
				</div>
			</div>
			<div class="card-footer" style="display: flex; justify-content: center;">
				<app-loading-button [object]="buttonSave" (clicked)="saveAccountant()"
					[disabled]="invalidEmail || !newAccountant.mail || !newAccountant.name || !newAccountant.nit || !newAccountant.phone || !newAccountant.taxRegime"></app-loading-button>
			</div>
		</div>
		<app-partners-not-associated [hidden]="tab != '1'"></app-partners-not-associated>
		<app-partners-associated [hidden]="tab != '2'"></app-partners-associated>
		<!-- <div class="card" [hidden]="tab != '2'">
			<div class="card-header">
				<h1>Participación</h1>
			</div>
			<div class="form-group">
				<label for="searchCommission" class="form-label">Buscar empresa </label>
				<input type="text" placeholder="Ingresa nombre de empresa" id="searchCommission" name="searchCommission"
					class="form-control">
			</div>
			<div class="table-responsive mt-3">
				<table class="table table-bordered" style="margin-bottom: 0;">
					<thead>
						<tr class="tr-middle">
							<th>Código</th>
							<th>NIT</th>
							<th>Nombre</th>
							<th>Total</th>
							<th>Participacion</th>
						</tr>
					</thead>
					<tbody>
						<tr class="tr-middle" *ngFor="let comission of paginationComission.filter">
							<td>{{comission.alphanumericId}}</td>
							<td>{{comission.nit}}</td>
							<td>{{comission.name}}</td>
							<td>{{comission.total | currency:'Q'}}</td>
							<td>{{comission.commission | currency: 'Q'}}</td>
						</tr>
						<tr class="tr-middle" *ngIf="paginationComission.filter.length == 0">
							<td colspan="5" class="text-muted">
								<i class="fa fa-circle-info"></i> {{failedStart?
								'No se pudieron obtener las participaciones, fallo en el servidor':'No se encontraron
								resultados'}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<app-pagination-custom id="comission" [elements]="paginationComission"></app-pagination-custom>
		</div> -->
	</div>
</div>